if (DEVELOPMENT_SERVER) {
  import('../_desktop/scss/main.scss')
    .then(() => {
      const linkElement = document.querySelector(`link[href^="${CSS_PATH}"]`);
      if (linkElement) {
        linkElement.disabled = true;
      }
    })
    .catch((error) => {
      console.error('Import SCSS error:', error);
    });
}

document.addEventListener('DOMContentLoaded', () => {
  /* new gen */
  import('@v2/environment/energycasino/environment-web').then((module) => {
    module.initEnvironment();
  });

  /*
   * Deprecated
   */
  loadServiceWorkers();
  loadWakeLockScreen();
  loadInitLanguage();
  loadInitSlider();
  loadInitGames();
  loadInitDarkModeCheck();
  loadInitUserInfoService();
  loadInitUserBalance();
  loadInitGamesSearch();
  loadInitGamesDescriptions();
  loadInitNav();
  loadInitLatestWinners();
  loadInitJackpots();
  loadInitPromotionsNTournamentsWidget();
  loadInitPromotionsList();
  loadInitOptInPromotion();
  loadInitPromotionOverlay();
  loadInitRegisterPromo();
  loadInitWelcomeOfferCards();
  loadInitEnergyPointsWidget();
  loadInitEnergyChests();
  loadInitFilters();
  loadInitTournaments();
  loadInitTournamentsPrizes();
  loadInitStaticConvertion();
  loadInitSupport();
  loadInitResponsibleGamingLinks();
  loadInitLandingPage();
  loadInitEnergyShop();
  loadInitAccordion();
  loadInitScroller();
  loadInitPromoCodes();
  loadInitMutationObservers();
  loadInitPaymentModal();
  loadInitFillLogin();
  loadInitShare();
  loadInitCookies();
  loadInitConversionTimeZone();
  loadPromotionViewLegalInfo();
  loadTournamentViewLegalInfo();
  loadAnimations();
  loadInitXmas();
  loadInitBlockbusterWeek();
  loadInitDevPanel();
  loadInitPayNgo();
  loadInitLotteryEnergyChest();

  loadInitPrefooters();

  loadInitUpdateGames();
  //loadInitLazyLoading();

  /* TEST NEW GAME MODAL STATIC */
  loadInitDynamicElements();
  loadInitRunGame();
  loadInitStopGame();

  loadInitLoginStatus();
});

var windowWidth = window.innerWidth;
window.onresize = function () {
  if (window.innerWidth != windowWidth) {
    resizeAccordion();
    windowWidth = window.innerWidth;
  }
  loadInitWelcomeOfferCards();

  //  resizeGamesTags();
};
window.onload = function () {};

async function loadInitLanguage() {
  const moduleBasicFunc = await import('./tools/cookies');
  if (!!_CMS_LOCALE || !!_CMS_LANGUAGE) moduleBasicFunc.setCookie('lang', _CMS_LOCALE || _CMS_LANGUAGE, 30);
}

/**
 * Games
 */
async function loadInitGames() {
  const { initRunGameClickEventHandler } = await import('./games/games.js');
  initRunGameClickEventHandler();
  if (document.querySelector('.games')) {
    const { initGames } = await import('./games/games.js');
    initGames();
  }
  if (document.querySelector('.games-list')) {
    const { initGamesList } = await import('./games/games.js');
    initGamesList();
  }
}

async function loadInitDarkModeCheck() {
  const moduleTools = await import('./tools/tools-base.js');
  const moduleBasicFunc = await import('./tools/cookies.js');
  const DarkModeCookie = moduleBasicFunc.getCookie('prefers_color_scheme');
  const toggleList = document.querySelectorAll('.js-colorModeToggle');
  let darkMode = DarkModeCookie == 'dark';

  moduleTools.initDarkModeCheck(darkMode);
  toggleList?.forEach((toggle) =>
    toggle.addEventListener('click', () => {
      darkMode = !darkMode;
      moduleTools.initDarkModeCheck(darkMode);
    })
  );
}

async function loadInitUserInfoService() {
  const { initUserInfoService } = await import('./user/userInfo-service');
  initUserInfoService();
}

async function loadInitUserBalance() {
  if (
    document.querySelector('.js-cms-full-user-balance') ||
    document.querySelector('.js-cms-user-balance') ||
    document.querySelector('.js-cms-mixed-balance') ||
    document.querySelector('.js-cms-bonus-balance') ||
    document.querySelector('.js-cms-realbonus-balance')
  ) {
    const { initUserBalance } = await import('./user/balance.js');
    initUserBalance();
  }
}

async function loadInitGamesSearch() {
  if (document.querySelector('.js-open-search')) {
    const moduleGamesSearch = await import('./games/desktop/game-search/games-search-desktop');
    moduleGamesSearch.initGamesSearchModal();
  }
}
/**
 * GamesDescriptions
 */
async function loadInitGamesDescriptions() {
  if (document.querySelector('.page-game-description')) {
    const { initGamesDescriptions, initRunGameDescriptions } = await import(
      './games/both/game-descriptions/games-descriptions'
    );
    const { initGamesDesc } = await import('./games/games.js');

    initGamesDescriptions();
    initRunGameDescriptions();
    initGamesDesc();
  }
}

/*
 * Slider
 */
async function loadInitSlider() {
  if (document.querySelector('.sliders')) {
    const moduleSlider = await import('./slider/slider.js');
    moduleSlider.initSlider();
  }
}

/*
 * Panels
 */
async function loadInitLatestWinners() {
  if (document.querySelector('.panels.winners')) {
    const moduleWinners = await import('./panels/latest-winners.js');
    moduleWinners.initLatestWinners();
  }
}
async function loadInitJackpots() {
  if (document.querySelector('.panels.jackpots')) {
    const moduleJackpots = await import('./panels/jackpots.js');
    moduleJackpots.initJackpots();
  }
  if (document.querySelector('.jackpot-banner') || document.querySelector('.promotion-banner')) {
    const moduleJackpots = await import('./panels/jackpots.js');
    moduleJackpots.initJackpotBanner();
  }
}

async function loadInitPromotionsNTournamentsWidget() {
  if (document.querySelector('.panels.promotions-n-tournaments')) {
    const module = await import('./panels/promotions-n-tournaments-widget.js');
    module.initPromotionsNTournamentsWidget();
  }
}

/*
 * Promotions
 */
async function loadInitPromotionsList() {
  if (document.querySelector('.promotion-list')) {
    const module = await import('./promotions/promotions.js');
    module.initPromotionsList();
  }
}
async function loadInitOptInPromotion() {
  if (document.querySelector('.opt-in')) {
    const module = await import('./promotions/promotions-opt-in.js');
    module.initOptInPromotion();
  }
}
async function loadInitPromotionOverlay() {
  if (document.querySelector('.promotion-overlay')) {
    const module = await import('./promotions/promotion-overlay.js');
    module.initPromotionOverlay();
  }
}
async function loadInitRegisterPromo() {
  const modulePromotions = await import('./promotions/promotions.js');
  modulePromotions.initRegisterPromo();
}
async function loadInitWelcomeOfferCards() {
  if (document.querySelector('.welcome-offer')) {
    const module = await import('./promotions/promotions.js');
    module.initWelcomeOfferCards();
  }
}
async function loadInitEnergyPointsWidget() {
  if (document.querySelector('.energy-spins')) {
    const module = await import('./promotions/promotions.js');
    module.initEnergyPointsWidget();
  }
}
async function loadInitEnergyChests() {
  if (window.location.hash === '#action-freespin' || document.querySelector('.modal-cms.energychest')) {
    const module = await import('./promotions/energychest-modal.js');
    module.initEnergyChestModal();
  }
  if (document.querySelector('.page-promotion.energyChests')) {
    const module = await import('./promotions/energychest.js');
    module.initEnergyChestPage();
  }
  if (document.querySelector('.energychest')) {
    const module = await import('./promotions/energychest.js');
    module.initEnergyChests();
  }
}
async function loadInitLotteryEnergyChest() {
  if (document.querySelector('.landingPage-lottery')) {
    const module = await import('./promotions/lottery-energychest.js');
    module.initLotteryEnergyChestPage();
  }
}

async function loadInitXmas() {
  if (
    document.querySelector('.landingPage-special-calendar-2023') ||
    document.querySelector('.landingPage-special-calendar-2024')
  ) {
    const module = await import('./promotions/promotion-xmas.js');
    module.initXmasPage();
  }
}

async function loadInitBlockbusterWeek() {
  if (document.querySelector('.landingPage-blockbuster-week-calendar')) {
    const module = await import('./promotions/promotion-blockbuster-week.js');
    module.initBlockbusterWeekPage();
  }
}

async function loadInitFilters() {
  if (document.querySelector('.js-open-filters')) {
    const moduleFilters = await import('./filters/filters.js');
    moduleFilters.initFiltersButton();
  }
}

async function loadInitTournaments() {
  if (document.querySelector('.tournaments-active')) {
    const moduleTournaments = await import('./tournaments/tournaments.js');
    moduleTournaments.initTournamentsList();
  }
  if (document.querySelector('.page-tournament')) {
    const moduleTournaments = await import('./tournaments/tournaments.js');
    moduleTournaments.initTournamentPage();
  }
}

async function loadInitTournamentsPrizes() {
  if (document.querySelector('.page-tournament') && document.querySelector('.tournament-prize')) {
    const moduleTournamentsPrizes = await import('./tournaments/tournaments-prizes.js');
    moduleTournamentsPrizes.initTournamentsPrizes();
  }
}

async function loadInitStaticConvertion() {
  let conversionElList = document.querySelectorAll('.js-cms-static-conversion');
  if (conversionElList.length > 0) {
    for (let i = 0, len = conversionElList.length; i < len; i++) {
      let el = conversionElList[i];
      const moduleTournamentsPrizes = await import('./tournaments/tournaments-prizes.js');
      el.innerText = moduleTournamentsPrizes.getTournamentsPrizeConvertion(el.innerText);
    }
  }
}

/**
 * NAV
 */
async function loadInitNav() {
  if (document.querySelector('.js-open-menu')) {
    const module = await import('./navigation/navigation.js');
    module.initSwitchNav();
  }
  if (document.querySelector('.language-select')) {
    const module = await import('./navigation/navigation.js');
    module.initSwitchLang();
  }
  if (document.querySelector('.js-back-button')) {
    const module = await import('./navigation/navigation.js');
    module.initBackButton();
  }
  if (document.querySelector('.nav')) {
    const module = await import('./navigation/navigation.js');
    module.initMatchNavItems();
  }
  if (
    document.querySelector('.js-form-login') ||
    document.querySelector('.nav .btn-login') ||
    document.querySelector('.navigation .btn-login')
  ) {
    const moduleObserver = await import('./observers/observers.js');
    moduleObserver.initModalLoginMutationObserver();
  }
  if (document.querySelector('.nav .btn-login') || document.querySelector('.navigation .btn-login')) {
    const moduleBasicFunc = await import('./tools/basic-functions.js');
    const handler = async (e) => {
      e.preventDefault();
      document.querySelector('.modal-login').classList.add('active');
      document.body.classList.add('modal-open');
      document.body.classList.add('modal-login-open');
      document.querySelector('#headerLogin').focus();
      const moduleFillLogin = await import('./user/fill-login');
      moduleFillLogin.fillLogin();
    };
    document.querySelectorAll('.nav .btn-login').forEach((btn) =>
      btn.addEventListener('click', (e) => {
        handler(e);
      })
    );
    document.querySelectorAll('.navigation .btn-login').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        const navbarToggle = document.querySelector('.js-open-menu');
        moduleBasicFunc.simulateClick(navbarToggle);
        handler(e);
      });
    });
  }
  if (document.querySelector('.modal-login')) {
    const moduleBasicFunctions = await import('./tools/basic-functions.js');
    document.querySelector('.modal-login .js-close').addEventListener('click', () => {
      if (document.querySelector('#modal .close')) {
        moduleBasicFunctions.simulateClick(document.querySelector('#modal .close'));
      }
      document.querySelector('#modal').classList.remove('d-none');
      document.querySelector('.modal-login').classList.remove('active');
      document.body.classList.remove('modal-open');
      document.body.classList.remove('modal-login-open');
    });
    document.querySelector('.modal-login .js-password-switch').addEventListener('click', (e) => {
      e.currentTarget.parentNode.classList.toggle('active');
      if (e.currentTarget.parentNode.classList.contains('active')) {
        e.currentTarget.parentNode.querySelector('input').setAttribute('type', 'text');
      } else {
        e.currentTarget.parentNode.querySelector('input').setAttribute('type', 'password');
      }
    });
    let urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('login')) {
      const url = new URL(window.location);
      url.searchParams.delete('login');
      history.pushState({}, '', url);
      const checkStatus = setInterval(() => {
        const classes = document.body.classList;
        if (classes.contains('js-loggedin') || classes.contains('js-anonymous')) {
          if (classes.contains('js-anonymous')) {
            moduleBasicFunctions.simulateClick(document.querySelector('.nav .btn-login'));
          }
          clearInterval(checkStatus);
        }
      }, 50);
    }
  }
  if (document.querySelector('.js-full-screen')) {
    const moduleNav = await import('./navigation/navigation.js');
    document.querySelector('.js-full-screen').addEventListener('click', () => {
      moduleNav.toggleFullScreen();
    });
  }
  if (document.querySelector('.js-cms-open-ecchest-popup')) {
    const moduleNav = await import('./navigation/navigation.js');
    moduleNav.initEnergyChestGameWindowPopup();
  }
  /*if(document.querySelector('.nav-banner-wrapper')){
        const module = await import('./navigation/navigation.js');
        module.initBanner();
    }*/
  if (document.querySelector('.nav-banner-wrapper .legalinfo')) {
    const moduleFootnote = await import('./footnote/footnote.js');
    moduleFootnote.initFootnotePopup(document.querySelector('.nav-banner-wrapper'));
  }
}

/**
 * Support
 */
async function loadInitSupport() {
  if (document.querySelector('.page-support')) {
    const module = await import('./support/support.js');
    module.initFaqList();
  }
}

async function loadInitResponsibleGamingLinks() {
  if (document.querySelector('.page-tnc .js-action.text-link')) {
    const moduleNav = await import('./navigation/navigation.js');
    moduleNav.initResponsibleGamingLinks();
  }
}

/**
 * Landing Page
 */
async function loadInitLandingPage() {
  if (document.querySelector('.landingPage')) {
    const module = await import('./landing-page/landing-page.js');
    module.initLandingPage();
  }
}

async function loadInitEnergyShop() {
  if (document.querySelector('.energyShop-cashback')) {
    const { initShopCashback } = await import('./shop/shop-cashback/shop-cashback.js');
    initShopCashback();
  }
  if (document.querySelector('.energyShop-products')) {
    const { initShopSliders } = await import('./shop/shop-slider/shop-slider.js');
    initShopSliders();
  }
  if (document.querySelector('.energyShop-item')) {
    const { initShopItemPage } = await import('./shop/shop-item-page/shop-item-page.js');
    initShopItemPage();
  }
}

/*
 * Tools
 */
async function loadInitAccordion() {
  if (document.querySelector('.accordion')) {
    const module = await import('./tools/tools-base.js');
    module.initAccordion();
  }
  if (document.querySelector('.license-accordion')) {
    const module = await import('./tools/tools-base.js');
    module.initLicenseAccordion();
  }
}

async function resizeAccordion() {
  if (document.querySelector('.js-filter-header')) {
    const moduleGames = await import('./games/games.js');
    moduleGames.countFiltersBodyHeight();
  }
  if (document.querySelector('.accordion')) {
    const moduleTools = await import('./tools/tools-base.js');
    moduleTools.resizeAccordion();
  }
}

async function loadInitScroller() {
  if (document.querySelector('.js-scroller')) {
    const module = await import('./tools/tools-base.js');
    module.initScroller();
  }
}

async function loadInitPromoCodes() {
  if (document.querySelector('.js-promo-codes')) {
    import('./promo-codes/promo-codes.js');
  }
}

async function loadInitMutationObservers() {
  loadInitPaymentsMutationObserver();
  loadInitTournamentCounterMutationObserver();
  loadInitGameWindowMutationObserver();
}

async function loadInitPaymentsMutationObserver() {
  if (document.querySelector('.payments-module')) {
    const moduleObserver = await import('./observers/observers.js');
    moduleObserver.initPaymentMutationObserver();
  }
}

async function loadInitGameWindowMutationObserver() {
  const { initGameWindowMutationObserver } = await import('./observers/observers');
  initGameWindowMutationObserver();
}

async function loadInitPaymentModal() {
  const { initPaymentModal } = await import('./modals/paymentModal');
  initPaymentModal();
}

async function loadInitTournamentCounterMutationObserver() {
  if (document.querySelector('.modal-game')) {
    const moduleObserver = await import('./observers/observers.js');
    moduleObserver.initTournamentCounterMutationObserver();
  }
}

async function loadInitShare() {
  if (document.querySelector('.js-share')) {
    const module = await import('./tools/basic-functions.js');
    module.click('.js-share', module.urlShare);
  }
}

async function loadInitCookies() {
  if (document.querySelector('.cookie-consent')) {
    const moduleTools = await import('./tools/tools-base.js');
    moduleTools.initCookies();
  }
}

async function loadInitConversionTimeZone() {
  if (document.querySelector('.js-cms-timezone-conversion')) {
    const module = await import('./tools/timezone-conversion.js');
    module.initTimeZoneConversion();
  }
}

async function loadPromotionViewLegalInfo() {
  if (document.querySelector('.page-promotion .legalinfo')) {
    const moduleFootnote = await import('./footnote/footnote.js');
    moduleFootnote.initFootnotePopup(document.querySelector('.page-promotion'));
  }
}

async function loadTournamentViewLegalInfo() {
  if (document.querySelector('.page-tournament .legalinfo')) {
    const moduleFootnote = await import('./footnote/footnote.js');
    moduleFootnote.initFootnotePopup(document.querySelector('.page-tournament'));
  }
}

async function loadAnimations() {
  if (document.querySelector('.js-scroll-scale')) {
    const moduleAnimations = await import('./tools/animations.js');
    moduleAnimations.scaleOnScroll(document.querySelector('.js-scroll-scale'));
    if (window.innerHeight < 650) {
      document.body.classList.add('small-screen');
    }
  }
  if (document.querySelector('.js-scale-main-background')) {
    const moduleAnimations = await import('./tools/animations.js');
    moduleAnimations.scaleBackgroundImageOnScroll(document.querySelector('.js-scale-main-background'));
    if (window.innerHeight < 650) {
      document.body.classList.add('small-screen');
    }
  }
}

async function loadInitDevPanel() {
  if (document.querySelector('.js-cms-hide-env-panel')) {
    const moduleNav = await import('./navigation/navigation.js');
    moduleNav.initEnvPanel();
  }
}

async function loadInitPayNgo() {
  if (document.querySelector(".csb-modal-container")) {
    const modulePayngo = await import("./payments/payngo.js");
    modulePayngo.init();
  }
}

async function loadInitFillLogin() {
  if (document.querySelector('.js-form-login button[type="submit"]')) {
    const moduleFillLogin = await import('./user/fill-login');
    moduleFillLogin.initFillLogin();
  }
}

function loadServiceWorkers() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register(`${JS_PATH}worker.js`)
        .then(async () => {
          console.log('SW registration successful');
          //const { initOptimove } = await import('./_v2/third-party/shared/optimove/optimove-service.js');
          //initOptimove();
        })
        .catch((error) => {
          if (typeof error !== 'undefined') {
            return console.log('SW registration failed: ', error);
          }
          console.log('SW registration failed');
        });
    });
  }
}

/*
 * Prefooters
 */
async function loadInitPrefooters() {
  const module = await import('./prefooter/prefooter.js');

  if (document.querySelector('.accordion-sText')) {
    module.initPrefooter();
  }

  if (document.querySelector('.pre-footer-full')) {
    module.initPrefooterModal();
  }
}

/*
 * Update games in background
 */
async function loadInitUpdateGames() {
  const moduleGames = await import('./games/games');
  moduleGames.initUpdateGames();
}

async function loadInitDynamicElements() {
  const { initializeDynamicElements } = await import('./games/window/dynamic/dynamic-elements');
  initializeDynamicElements();
}

async function loadInitRunGame() {
  const gameSlug = document.body.getAttribute('data-run-game');
  if (!gameSlug) return;
  const { runGameBySlug } = await import('./games/utilities');
  runGameBySlug(gameSlug);
}

async function loadInitStopGame() {
  const { initStopGameEventHandler } = await import('./games/games');
  initStopGameEventHandler();
}

async function loadInitLoginStatus() {
  if (document.querySelector('#input-dev-env-domain')) {
    const { initLoginStatus } = await import('./tools/basic-functions.js');

    initLoginStatus();
  }
}

async function loadWakeLockScreen() {
  const { initWakeLockService } = await import('./games/window/service/wake-lock-service');
  initWakeLockService();
}

/*
 * LazyLoadImage
 *
async function loadInitLazyLoading() {
    const moduleLazyImage = await import('./tools/lazyload.js');
    moduleLazyImage.initLazyLoading();
}
 */
